import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import ActionItemList from 'Components/UI/ActionItems/ActionItemList';

const useStyles = makeStyles(theme => ({
  actionItemHeader: {
    margin: theme.spacing(6, 0, 2),
  },
}));

export default function ActionItemSection({
  actionItemCollection,
  assignedToHousehold,
  replaceActionItem,
  refreshActionItems,
  readOnly,
}) {
  const classes = useStyles();

  return (
    <>
      <Typography
        className={classes.actionItemHeader}
        variant="h2"
        color="primary"
      >
        {assignedToHousehold ? "Your To-Do's" : "Our Planner's To-Do's"}
      </Typography>
      <ActionItemList readOnly={readOnly} actionItemCollection={actionItemCollection} replaceActionItem={replaceActionItem} refreshActionItems={refreshActionItems} />
    </>
  );
}

ActionItemSection.propTypes = {
  actionItemCollection: PropTypes.object.isRequired,
  replaceActionItem: PropTypes.func.isRequired,
  refreshActionItems: PropTypes.func.isRequired,
  assignedToHousehold: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
};
